import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { token } from "@atlaskit/tokens";

import {
    JiraFFLOverlayTemplate,
    JiraOverlayTemplate,
    LayoutVersion
} from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { experiments, useExperiment } from "@/utils/experiment";
import { FeatureExposed } from "@/utils/feature-exposed";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { useLocation } from "@/utils/location-provider";

import { CreateASiteHeading } from "../../../components";

export const LoggedInJiraNewUser = () => {
    const version = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    )
        ? LayoutVersion.V3
        : LayoutVersion.V1;

    const experiment = useExperiment(
        experiments.jiraContactAndCompanyExpandSiteActivation
    );

    const location = useLocation();
    const searchParameters = new URLSearchParams(location.search);
    const cgsKey = searchParameters.get("cgsKey") as string | undefined;

    const useContactExpandCohortLogic =
        experiment.type === "enrolled" && experiment.value;

    const frictionLessFirstLookEnabled = useExperiment(
        experiments.cfind4666JiraFfl
    );
    const isFrictionLessFirstLook =
        frictionLessFirstLookEnabled.type === "enrolled" &&
        frictionLessFirstLookEnabled.value;
    if (isFrictionLessFirstLook && cgsKey) {
        return (
            <JiraFFLOverlayTemplate size="sm">
                <div css={containerCss}>
                    <div css={headerGroupCss}>
                        <h1 css={headerCss}>
                            <span css={accentImageSpanCss}>
                                <CreateASiteHeading />
                            </span>
                        </h1>
                        <p css={headerCss}>
                            <FormattedMessage
                                id="siteActivation.loggedInJira.newUser"
                                defaultMessage="Sites are the shared space where people organize teams, work, and projects."
                            />
                        </p>
                    </div>
                    <SiteActivation />
                </div>
            </JiraFFLOverlayTemplate>
        );
    }

    return (
        <FeatureExposed
            experimentKey="jfind-1565-sign-up-flow-overlay"
            group="Test"
        >
            <JiraOverlayTemplate size="sm" version={version}>
                <div css={containerCss}>
                    <div css={headerGroupCss}>
                        <h1 css={headerCss}>
                            <span css={accentImageSpanCss}>
                                <CreateASiteHeading />
                            </span>
                        </h1>
                        <p css={headerCss}>
                            <FormattedMessage
                                id="siteActivation.loggedInJira.newUser"
                                defaultMessage="Sites are the shared space where people organize teams, work, and projects."
                            />
                        </p>
                    </div>
                    <SiteActivation
                        useContactExpandCohortLogic={
                            useContactExpandCohortLogic
                        }
                    />
                </div>
            </JiraOverlayTemplate>
        </FeatureExposed>
    );
};

const containerCss = css({
    display: "flex",
    flexDirection: "column"
});

const headerGroupCss = css({
    display: "grid",
    gap: token("space.100")
});

const headerCss = css({
    margin: 0,
    textAlign: "center"
});

const accentImageSpanCss = css({
    position: "relative"
});
